import email from '../assets/email.png';
import mobile from '../assets/mobile.png';

import css from '../assets/css.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import tailwind from "../assets/tailwind.svg"
import vite from "../assets/vite.svg"
import nextjs from "../assets/nextjs.svg"

import profile from '../assets/profile.png';
import shape from '../assets/shape.svg';
import logo from '../assets/logo.png';

export default {
    email,
    mobile,
    css,
    html,
    javascript,
    node,
    react,
    sass,
    profile,
    shape,
    logo,
    typescript,
    tailwind,
    vite,
    nextjs
};